import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

// eslint-disable-next-line import/first
import React from 'react';
// eslint-disable-next-line import/first
import ReactDOM from 'react-dom';
// eslint-disable-next-line import/first
import Application from './Application';
// eslint-disable-next-line import/first
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
    (
      // eslint-disable-next-line react/jsx-filename-extension
      <Application
        platformReducers={{}}
        platformSagas={[]}
        platformInitializers={[]}
      />
    ),
    // eslint-disable-next-line no-undef
    document.getElementById('root'),
  );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
